import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthClassicSignIn() {
	return <AuthShell variant="classic"><AuthForm variant="classic" mode="sign-in" /></AuthShell>;
}

export default AuthClassicSignIn;
